<template>
  <header class="ba-relative ba-mb-8 ba-text-center">
    <a
      v-if="showBackButton"
      href="#!"
      class="ba-absolute ba-right-full ba--top-2 ba-w-10 ba-h-10 hover:ba-opacity-75"
      @click.prevent="$emit('click')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="ba-w-full ba-h-full"
      >
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
      </svg>
    </a>
    <h2 class="ba-mb-2 ba-text-xl ba-font-bold">{{ title }}</h2>
    <template v-if="messages.length > 1">
      <div class="vis-manage-password-messages">
        <p
          v-for="(message, i) in messages"
          :key="i"
          class="2xs:ba-px-4 xs:ba-px-2 ba-leading-5 ba-mb-2 ba-text-left"
          :class="descriptionClasses"
        >
          {{ message }}
        </p>
      </div>
    </template>
    <p
      v-else-if="description"
      class="2xs:ba-px-4 xs:ba-px-2"
      :class="descriptionClasses"
    >
      {{ description }}
    </p>
  </header>
</template>

<script>
export default {
  name: "v-page-manage-header",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    descriptionType: {
      type: String,
      default: ""
    },
    messages: {
      type: Array,
      default: () => []
    },
    showBackButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    descriptionClasses() {
      return {
        "ba-text-white ba-text-opacity-50":
          !this.descriptionType || this.descriptionType === "normal",
        "ba-text-error": this.descriptionType === "error",
        "ba-text-success": this.descriptionType === "success"
      };
    }
  }
};
</script>
